import { InjectionToken, Provider } from '@angular/core';

export const SELECTOR_BADGE_OPTIONS = new InjectionToken<SelectorBadgeOptions>('SELECTOR_BADGE_OPTIONS');

export interface SelectorBadgeOptions {
  colorMap: Record<string, string>;
  labelMap: Record<string, string>;
}

export function provideSelectorBadgeOptions(options: SelectorBadgeOptions): Provider[] {
  return [
    {
      provide: SELECTOR_BADGE_OPTIONS,
      useValue: options,
    },
  ];
}
